// extracted by mini-css-extract-plugin
export default {"bannerComponent":"Banner_bannerComponent__-VxzS"};